// src/App.js
import { Fragment, useState, useEffect, useRef } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import Navigation from "./components/navigation/Navigation";
import Footer from "./components/footer/Footer";
import FooterHeader from "./components/footerHeader/FooterHeader";
import SideBar from "./components/sideBar/SideBar";
import DrawerCart from "./components/drawer/Drawer";
import Login from "./components/login/Login";
import Register from "./components/register/Register";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import FAQ from "./pages/FAQ";
import Product from "./components/product/Product";
import Checkout from "./components/checkout/Checkout";
import Order from "./components/order/Order";
import User from "./components/user/User";
import Dashboard from "./components/dashboard/Dashboard";
import ChangePassword from "./components/changePassword/ChangePassword";
import MyOrders from "./components/myOrders/MyOrders";
import UpdateProfile from "./components/updateProfile/UpdateProfile";
import Offers from "./pages/Offers";
import Search from "./components/search/Search";
import Loading from "./components/loading/Loading";

function App() {
  let [isOpenRegister, setIsOpenRegister] = useState(false);
  const navigate = useNavigate();
  const isInitialLoad = useRef(true);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isInitialLoad.current && window.location.pathname !== "/") {
      navigate("/", { replace: true });
    }
    isInitialLoad.current = false;
  }, [navigate]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Fragment>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="404" element={<NotFound />} />
        <Route path="about-us" element={<About />} />
        <Route path="contact-us" element={<Contact />} />
        <Route path="FAQ" element={<FAQ />} />
        <Route path={"product/:productTitle"} element={<Product />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="search" element={<Search />} />
        <Route path={"order/:id"} element={<Order />} />
        <Route path="offer" element={<Offers />} />
        <Route path="user" element={<User />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>
        <Route path="*" element={<Home />} />
      </Routes>
      <div>
        <FooterHeader />
      </div>
      <div>
        <SideBar />
        <DrawerCart />
        <Login setIsOpenRegister={setIsOpenRegister} />
        <Register
          isOpen={isOpenRegister}
          setIsOpenRegister={setIsOpenRegister}
        />
      </div>
      <div className="w-full">
        <Footer />
      </div>
    </Fragment>
  );
}

export default App;